import { ApplicationState } from '../types';

export const EMPTY_COST_BASIS_MAP = {};

/**
 * Simple selector to costBasisMap
 */
export const getCostBasisMap = ({ costBasis }: ApplicationState) =>
  costBasis.costBasisMap || EMPTY_COST_BASIS_MAP;
